

























































































import {Vue, Component, Emit, Ref} from 'vue-property-decorator';
import MallSelect from '@/components/common/claim/contentTop/MallSelect.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import CheckBoxElement from '@/components/common/CheckBoxElement.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import { Mall } from 'ncp-api-supporter';
import { State } from 'vuex-class';
import { formDataInit, searchTypeSelectList, periodOption, taskMessageStatusTypeList, taskMessageTypeOption } from './MessageListValues';

@Component({
  components: {
    MallSelect,
    CompSelectBox,
    PeriodDateCalendar,
    CheckBoxElement
  },
})
export default class MessageListTop extends Vue {
  @State('malls', { namespace: 'mall' }) 
  private readonly malls!: Mall[];
  @Ref() 
  private readonly calendar: PeriodDateCalendar;
  @Emit('changeFormData')
  private changeFormData() {
    return this.formData;
  }

  private readonly searchTypeSelectList = searchTypeSelectList;
  private readonly periodOption = periodOption;
  private readonly taskMessageStatusTypeList = taskMessageStatusTypeList
  private readonly taskMessageTypeOption = taskMessageTypeOption
  private formData = { ...formDataInit };

  private get mallList() {
    return this.malls.map(({ mallNo: value, mallName: name }) => ({ value, name }))
  }

  private reset() {
    this.formData = { ...formDataInit };
    this.calendar.clickPeriod('3m');
  }
}
